// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    background: #EDF5FF !important;
    margin: 0px;
    padding: 0px;
  }
  .header_section{
    background-color: #0A83FF;
    padding: 0px 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .header_section .logo_section svg{
    width: 134px;
    height: 35px;
  }
  .header_section .navbar_section ul{
    margin: 0px;
    padding: 0px;
    list-style: none;
  }
  .header_section .navbar_section ul li{
    display: inline-block;
  }

  .header_section .navbar_section .link_section a:hover, .header_section .navbar_section .link_section a.active{
    border-bottom: 4px solid #fff;
    font-weight: 700;
  }
  .header_section .navbar_section .link_section a{
    text-decoration: none;
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    font-family: 'Montserrat', sans-serif;
    padding: 25px 20px;
    display: block;
    border-bottom: 4px solid transparent;
  }
  .header_section .user_name_section button{
    background-color: transparent;
    border: 0px;
    text-align: left;
  }
  .header_section .btn-check:checked+.btn, .header_section .btn.active, .header_section .btn.show, .header_section .btn:first-child:active{
    background-color: transparent;
  }
  .header_section .user_name_section .user_box{
    border: 1px solid #fff;
    width: 40px;
    height: 40px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }
  .header_section .user_name_section .user_box h2{
    margin: 0px;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 104%;
    font-family: 'Montserrat', sans-serif;
  }
  .header_section .user_name_section .text_section p{
    margin: 0px;
    color: #fff;
    font-weight: 400;
    font-size: 12px;
    line-height: 104%;
    font-family: 'Montserrat', sans-serif;
  }
  .header_section .user_name_section .text_section h6{
    margin: 0px;
    color: #fff;
    font-weight: 400;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 104%;
    font-family: 'Montserrat', sans-serif;
  }
  .header_section .user_name_section .text_section h6 svg{
    font-size: 8px;
    margin-left: 5px;
  }
  .header_section .user_name_section .dropdown button::after{
    display: none;
  }
  .d-flex{
    display: flex;
  }
  .align-center{
    align-items: center;
  }
  .dropdown-menu{
    display: none;
  }
  .dropdown-menu.show{
    display: block;
    background-color: #fff;
    
  }
  .header_section .user_name_section .dropdown-menu.show{
    padding: 20px;
    border-radius: 5px;
    width: 100px;
  }
  .header_section .user_name_section .dropdown-menu.show ul{
    list-style: none;
    padding: 0px;
    margin: 0px;
  }
  .header_section .user_name_section .dropdown-menu.show ul li:last-child{
    margin-bottom: 0px;
  }
  .header_section .user_name_section .dropdown-menu.show ul li{
    margin-bottom: 10px;
  }
  .header_section .user_name_section .dropdown-menu.show ul li a{
    color: #000;
    font-weight: 400;
    font-size: 14px;
    line-height: 104%;
    font-family: 'Montserrat', sans-serif;
    text-decoration: none;
  }
  .header_bottom_section{
    background-color: #FF5656;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }
  .header_bottom_section .subscribe_button{
    background-color: #60DA00;
    padding: 6px 15px;
    border-radius: 5px;
    font-weight: 700;
    font-size: 14px;
    color: #fff;
    font-family: 'Montserrat', sans-serif;
    margin-left: 20px;
  }
  .header_bottom_section p{
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    font-family: 'Montserrat', sans-serif;
    margin: 0px;
  }
  .mb-25{
    margin-bottom: 25px;
  }
  .story_box_section ul{
    margin: 0px;
    padding: 0px;
    list-style-type: none;
  }
  .story_box_section ul li{
    display: inline-block;
    margin-right: 15px;
    margin-bottom: 15px;
  }
  .story_box_section ul li:last-child{
    margin-right: 0px;
  }
  .story_box_section ul li ul{
    display: block;
  }
  .story_box_section ul li ul li{
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: 'Montserrat', sans-serif;
    margin: 0px 0px 10px;
    font-weight: 400;
    color: #000;
  }
  .story_box_section ul li ul li svg{
    font-size: 24px;
    color: #0A83FF;
    margin-right: 10px;
  }
  .story_box_section .story_subscribe{
    background-color: transparent;
    padding: 15px 50px;
    border: 1px solid #B8B5B5;
    border-radius: 20px;
    font-weight: 400;
    font-size: 16px;
    color: #B8B5B5;
    font-family: 'Montserrat', sans-serif;
  }
  .story_box_section .story_subscribe:hover{
    background-color: #0A83FF;
    color: #fff;
  }
  .subscribe_box_section ul{
    margin: 0px;
    padding: 0px;
    list-style-type: none;
    display: flex;
    justify-content: center;
  }
  .subscribe_box_section ul li{
    margin-right: 15px;
    margin-bottom: 15px;
  }
  .subscribe_box_section ul li:last-child{
    margin-right: 0px;
  }
  .subscribe_box_section ul li ul{
    display: block;
  }
  .subscribe_box_section ul li ul li{
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: 'Montserrat', sans-serif;
    margin: 0px 0px 10px;
    font-weight: 400;
    color: #000;
  }
  .subscribe_box_section ul li ul li svg{
    font-size: 24px;
    color: #0A83FF;
    margin-right: 10px;
  }
  .subscribe_box_section .story_subscribe{
    background-color: transparent;
    padding: 15px 50px;
    border: 1px solid #B8B5B5;
    border-radius: 20px;
    font-weight: 400;
    font-size: 16px;
    color: #B8B5B5;
    font-family: 'Montserrat', sans-serif;
  }
  .subscribe_box_section .story_subscribe:hover{
    background-color: #0A83FF;
    color: #fff;
  }
  .story_card{
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    width: auto;
    padding: 15px 18px;
  }
  .story_card .text_section{
    margin: 10px 0px 0px;
  }
  .story_card .text_section h3{
    font-size: 16px;
    line-height: 19px;
    font-family: 'Montserrat', sans-serif;
    margin: 0px 0px 15px;
    font-weight: 500;
    color: #000;
  }
  .story_card .text_section .btn_view{
    background-color: #0A83FF;
    border: 1px solid #0A83FF;
    padding: 5px 25px;
    border-radius: 5px;
    font-size: 12px;
    line-height: 16px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
  }
  .story_card .text_section a.btn_view{
    display: block;
  }
  .story_card .icon_section ul{
    margin: 0px;
    padding: 0px;
    list-style-type: none;
  }
  .story_card .icon_section li{
    display: inline-block;
    margin-right: 15px;
    margin-bottom: 0px;
  }
  .story_card .delete_icon a svg{
    color: #FF0000;
    font-size: 16px;
    margin-right: 10px;
  }
  .sidebarLayout__SidebarContainer-sc-hpe4no-1 .mediaPane__ButtonsWrapper-sc-usipec-3 div:first-child{
    display: none;
  }
  ./*layout__PageAreaWithoutOverflow-sc-1n0mp4m-7 .edit__Element-sc-ybci2b-0 img{
    left: 0px !important;
  }*/


  .publish_setting_page{
    background-color: #EDF5FF;
    padding: 30px 0px;
  }
  .container{
    padding: 0px 45px;
  }
  .main_heading{
    font-size: 32px;
    font-weight: 300;
    font-family: 'Montserrat', sans-serif;
    line-height: 42px;
    color: #000;
    margin: 0px;
  }
  .publish_setting_page .left_section{
    width: 70%;
  }
  .publish_setting_page .right_section{
    width: 30%;
    margin-left: 25px;
  }
  .publish_setting_page .page_data{
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
  }
  .publish_setting_page .page_data .inner_main_heading{
    font-size: 18px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    line-height: 24px;
    color: #000;
    margin: 0px 0px 25px;
  }
  .publish_setting_page .page_data .form_section{
    display: flex;
  }
  .publish_setting_page .field_section{
    margin-bottom: 20px;
  }
  .publish_setting_page .field_section .form-label{
    font-size: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    line-height: 19px;
    color: #000;
    margin: 0px;
  }
  .publish_setting_page .field_section .form-control{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: -webkit-fill-available;
    padding: 12px;
    margin: 7px 0px 0px;
  }
  .publish_setting_page .field_section .form-select{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: -webkit-fill-available;
    padding: 12px;
    margin: 7px 0px 0px;
    background-color: transparent;
  }
  .primary{
    background-color: #0A83FF;
    border-radius: 5px;
    padding: 12px 40px;
    border: 1px solid #0A83FF;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    line-height: 19px;
    cursor: pointer;
    box-shadow: 0px 4px 4px 0px #00000040;
  }
  a.primary{
    text-decoration: none;
  }
  .me-20{
    margin-right: 20px;
  }
  .rightbar_section{
    width: 100%;
    height: auto;
  }


  .contact_page{
    background-color: #EDF5FF;
    padding: 20px 45px;
  }
  .contact_page .head_section{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 25px;
  }
  .table_section tbody tr td a{
    cursor: pointer;
  }

  .customer-tag{
    background-color: #fff;
    padding: 0px;
  }
  .customer-tag .head_section{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 25px;
  }

  .main_heading{
    font-size: 32px;
    font-weight: 300;
    font-family: 'Montserrat', sans-serif;
    line-height: 42px;
    color: #000;
    margin: 0px;
  }
  .me-5{
    margin-right: 5px;
  }
  .secondary{
    background-color: #f5f5f5;
    border-radius: 5px;
    padding: 12px 20px;
    border: 1px solid #ccc;
    color: #000;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    line-height: 19px;
    cursor: pointer;
  }
  .contact_page .page_data{
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
  }
  .contact_page .table_section{
    width: 100%;
  }
  .contact_page .table_section thead tr th{
    text-align: left;    
    font-size: 14px;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    line-height: 18px;
    color: #000;
    padding: 0px 0px 10px;
  }
  .contact_page .table_section .user_section{
    display: flex;
    align-items: center;
  }
  .contact_page .table_section .user_section .user_box{
    width: 40px;
    height: 40px;
    background-color: #0A83FF;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
  .contact_page .table_section .user_section .user_box h4{
    margin: 0px;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    line-height: 18px;
    color: #fff;
  }
  .contact_page .table_section .user_section{
    margin: 0px;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    line-height: 18px;
    color: #000;
  }
  .contact_page .table_section tbody tr td{
    font-size: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    line-height: 18px;
    color: #000;
    margin: 0px;
    border-top: 1px solid #ccc;
    padding: 15px 0px;
    vertical-align: middle;
  }
  .contact_page .table_section tbody tr td .edit_link{
    color: #0A83FF;
    margin-right: 10px;
  }
  .contact_page .table_section tbody tr td .delete_link{
    color: #0A83FF;
    margin-left: 10px;
  }


  .analytic_page{
    background-color: #EDF5FF;
    padding: 20px 45px;
  }
  .main_heading{
    font-size: 32px;
    font-weight: 300;
    font-family: 'Montserrat', sans-serif;
    line-height: 42px;
    color: #000;
    margin: 0px;
  }
  .analytic_page .dashboard_box_section ul{
    margin: 0px;
    padding: 0px;
    list-style: none;
  }
  .analytic_page .dashboard_box_section ul li{
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 40px;
    width: 248px;
  }
  .analytic_page .dashboard_box_section .dashboard_box{
    background-color: #0A83FF;
    padding: 12px 20px;
    border-radius: 10px;
    border: 1px solid #ccc;
  }
  .analytic_page .dashboard_box_section .dashboard_box h1{
    margin: 0px;
    font-size: 32px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    line-height: 48px;
    color: #fff;
  }
  .analytic_page .dashboard_box_section .dashboard_box p{
    margin: 0px;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    line-height: 19px;
    color: #fff;
  }
  .analytic_page .page_data{
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
    height: 500px;
  }
  .analytic_page .chart_section{
    display: flex;
  }
  .analytic_page .w-40{
    width: 40%;
  }
  .analytic_page .w-25{
    width: 25%;
  }
  .me-10{
    margin-right: 10px;
  }


  .setting_page{
    background-color: #EDF5FF;
    padding: 20px 0px;
  }
  .setting_page .container{
    width: 1150px;
    margin: auto;
  }
  .main_heading{
    font-size: 32px;
    font-weight: 300;
    font-family: 'Montserrat', sans-serif;
    line-height: 42px;
    color: #000;
    margin: 0px;
  }
  .setting_page .page_data{
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
  }
  .setting_inner_section{
    display: flex;
  }
  .w-75{
    width: 75%;
  }
  .w-25{
    width: 25%;
  }
  .w-30{
    width: 30%;
  }
  .me-20{
    margin-right: 20px;
  }
  .setting_page .left_nav_section{
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 5px 0px;
  }
  .setting_page .left_nav_section ul{
    margin: 0px;
    padding: 0px;
    list-style: none;
  } 
  .setting_page .left_nav_section ul li a{
    display: flex;
    font-size: 14px;
    line-height: 19px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #000;
    text-decoration: none;
    padding: 10px 15px;
  }
  .setting_page .left_nav_section ul li a:hover{
    background-color: #EDF5FF;
    color: #0A83FF;
  }
  .setting_page .left_nav_section ul li a .img_icon{
    margin-right: 15px;
    display: block;
  }
  .setting_page .left_nav_section ul li a .img_active{
    margin-right: 15px;
    display: none;
  }
  .setting_page .left_nav_section ul li a.active .img_icon, .setting_page .left_nav_section ul li a:hover .img_icon{
    margin-right: 15px;
    display: none;
  }
  .setting_page .left_nav_section ul li a.active .img_active, .setting_page .left_nav_section ul li a:hover .img_active{
    margin-right: 15px;
    display: block;
  }
  .d-flex{
    display: flex;
  }
  .setting_page .field_section{
    margin-bottom: 30px;
  }
  .field_section .form-label{
    font-size: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    line-height: 19px;
    color: #000;
    margin: 0px;
  }
  .setting_page .field_section .form-control{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: -webkit-fill-available;
    padding: 12px;
    margin: 7px 0px 0px;
    font-size: 14px;
    line-height: 17px;
  }
  .setting_page .field_section .form-select{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: -webkit-fill-available;
    padding: 12px;
    margin: 7px 0px 0px;
    font-size: 14px;
    line-height: 17px;
    background-color: transparent;
  }
  .setting_page .page_data .inner_main_heading{
    font-size: 18px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    line-height: 24px;
    color: #000;
    margin: 0px 0px 25px;
  }
  .setting_page .color_select_section ul{
    margin: 10px 0px;
    padding: 0px;
    list-style: none;
  }
  .setting_page .color_select_section ul li{
    display: inline-block;
    margin-right: 10px;
  }
  .setting_page .color_select_section .color_box{
    width: 40px;
    height: 40px;
    border-radius: 50px;
    background-color: #DDE1E5;
    position: relative;
    display: flex;
  }
  .setting_page .color_select_section .color_box svg{
    color: #fff;
  }
  .setting_page .color_select_section .color_box .cross_box{
    width: 17px;
    height: 17px;
    background-color: #FF0000;
    position: absolute;
    top: 0px;
    border-radius: 50px;
    right: 0px;
    display: none;
  }
  .setting_page .color_select_section .color_box:hover .cross_box{
    display: flex;
  }
  .setting_page .table_section thead{
    background-color: #363B78;
  }
  .setting_page .table_section{
    border-spacing: 0px;
    width: 100%;
    border: 1px solid #ccc;
    margin-bottom: 30px;
  }
  .setting_page .table_section thead tr th{
    padding: 15px 12px;
    border-bottom: 1px solid #ccc;
    text-align: left;
    color: #fff;
    background-color: #0A83FF;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
  }
  .setting_page .table_section tbody tr td{
    padding: 10px 12px;
    border-bottom: 1px solid #ccc;
    text-align: left;
    color: #000;
    vertical-align: middle;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
  }
  .setting_page .table_section tbody tr td .form-select{
    width: 100%;
    margin: 0px;
  }
  .setting_page .table_section tbody tr td .field_section{
    margin-bottom: 0px;
  }
  .setting_page .table_section tbody tr td h1{
    font-size: 26px;
    margin: 0px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #000;
    line-height: 43px;
  }
  .setting_page .table_section tbody tr td h2{
    font-size: 22px;
    margin: 0px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #000;
    line-height: 36px;
  }
  .setting_page .table_section tbody tr td h3{
    font-size: 18px;
    margin: 0px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #000;
    line-height: 24px;
  }
  .setting_page .table_section tbody tr td{
    font-size: 14px;
    margin: 0px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #000;
    line-height: 19px;
  }
  .setting_page .table_section tbody tr td .edit_link{
    color: #0A83FF;
    margin-right: 10px;
  }
  .setting_page .table_section tbody tr td .delete_link {
    color: #0A83FF;
    margin-left: 10px;
  }
  .setting_page .table_section tbody tr td p{
    font-size: 14px;
    margin: 0px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #000;
    line-height: 19px;
  }
  .setting_page .table_section tbody tr:last-child td{
    border-bottom: 0px;
  }
  .setting_page .page_data .plan_section{
    border-bottom: 1px solid #CCCCCC;
    padding: 20px 0px;
  }
  .setting_page .page_data .plan_section h2{
    font-size: 14px;
    line-height: 19px;
    text-transform: uppercase;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    color: #2B2F27;
    margin: 0px 0px 20px;
  }
  .setting_page .page_data .plan_section .text_section h3{
    font-size: 14px;
    line-height: 19px;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    color: #2B2F27;
    margin: 0px;
  }
  .setting_page .page_data .plan_section .text_section span{
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #5C5F62;
    margin: 0px;
  }
  .setting_page .page_data .plan_section p{
    font-size: 14px;
    line-height: 19px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #2B2F27;
    margin: 0px;
  }
  .setting_page .page_data .plan_section p.amount_section{
    font-size: 16px;
    line-height: 21px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    color: #2B2F27;
    margin: 0px;
  }
  .setting_page .page_data .plan_section p span{
    font-size: 10px;
    line-height: 13px;
    font-weight: 400;
    color: #5C5F62;
  }
  .setting_page .page_data .plan_section .badge{
    background-color: #ACE8CF;
    border-radius: 15px;
    padding: 4px 10px;
    font-size: 8px;
    line-height: 10px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #000;
    text-transform: uppercase;
  }
  .setting_page .page_data .plan_section a{
    text-decoration: none;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #2F6DC9;
    margin: 0px;
  }
  .justify-content-between{
    justify-content: space-between;
  }
  .align-items-end{
    align-items: flex-end;
  }
  .mb-5{
    margin-bottom: 5px;
  }
  .mb-20{
    margin-bottom: 20px;
  }
  .ml-15{
    margin-left: 15px;
  }
  .me-10{
    margin-right: 10px;
  }
  .setting_page .page_data .invoices_section{
    padding: 20px 0px;
  }
  .setting_page .page_data .invoices_section h2{
    font-size: 14px;
    line-height: 19px;
    text-transform: uppercase;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    color: #2B2F27;
    margin: 0px 0px 20px;
  }
  .setting_page .page_data .invoices_section .table_section{
    border: 0px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
  .setting_page .page_data .invoices_section .table_section tr td h4{
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    color: #2B2F27;
    margin: 0px;
  }
  .setting_page .page_data .invoices_section .table_section tr td p{
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #5C5F62;
    margin: 0px;
  }
  .setting_page .page_data .invoices_section .badge{
    background-color: #ACE8CF;
    border-radius: 15px;
    padding: 4px 10px;
    font-size: 8px;
    line-height: 10px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #000;
    text-transform: uppercase;
  }
  .setting_page .page_data .invoices_section a{
    text-decoration: none;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #2F6DC9;
    margin: 0px;
  }
  .setting_page .page_data .invoices_section a img{
    margin-left: 10px;
  }
  .align-center{
    align-items: center;
  }
  .justify-content-end{
    justify-content: end;
  }
  .setting_page .page_data .owner_section{
    border-bottom: 1px solid #ccc;
    padding: 20px 0px;
  }
  .setting_page .page_data .owner_section .user_section{
    border-bottom: 1px solid #ccc;
    padding: 20px 0px;
  }
  .setting_page .page_data .owner_section .user_section:first-child{
    padding: 0px 0px 20px;
  }
  .setting_page .page_data .owner_section .user_section:last-child{
    padding: 20px 0px 0px;
    border-bottom: 0px; 
  }
  .setting_page .page_data .owner_section h2{
    font-size: 14px;
    line-height: 19px;
    text-transform: uppercase;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    color: #2B2F27;
    margin: 0px 0px 20px;
  }
  .setting_page .page_data .owner_section .text_section h2{
    font-size: 14px;
    line-height: 19px;
    text-transform: uppercase;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    color: #2B2F27;
    margin: 0px 0px 7px;
  }
  .setting_page .page_data .owner_section .text_section p{
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
   font-family: 'Montserrat', sans-serif;
    color: #5C5F62;
    margin: 0px;
  }
  .setting_page .page_data .owner_section .user_name_section{
    display: flex;
    align-items: center;
  }
  .setting_page .page_data .owner_section .user_dropdown button{
    background-color: transparent !important;
    border: 0px;
    padding: 0px;
  }
  .setting_page .page_data .owner_section .user_dropdown button::after{
    display: none;
  }
  .setting_page .page_data .owner_section .user_dropdown .dropdown-menu ul{
    margin: 0px;
    padding: 0px;
    list-style: none;
  }
  .setting_page .page_data .owner_section .user_name_section .user_box{
    width: 24px;
    height: 24px;
    background-color: #E3E4E6;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
  }
  .setting_page .page_data .owner_section .user_name_section .user_box h4{
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #8A8F94;
    margin: 0px;
  }
  .setting_page .page_data .owner_section .user_name_section .text_section h2{
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #2F6DC9;
    margin: 0px;
  }
  .setting_page .page_data .owner_section .user_name_section .text_section p{
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #5C5F62;
    margin: 0px;
  }
  .setting_page .page_data .owner_section a{
    text-decoration: none;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #2F6DC9;
    margin: 0px;
  }
  .create_user_form{
    padding: 10px;
  }
  .create_user_form .field_section label{
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    margin: 0px 0px 5px;
  }
  .create_user_form .field_section input{
    width: 100%;
    border: 1px solid #ccc;
    padding: 12px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    border-radius: 5px;
    margin: 0px 0px 3px;
  }
  .create_user_form .field_section{
    margin-bottom: 10px;
  }
  .create_user_form .field_section .chakra-form__error-message{
    font-size: 12px;
    line-height: 15px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #FF0000;
  }



/*Login Css*/

.login_page{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
}
.login_page p{
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #000;
  margin: 0px;
  font-family: 'Montserrat', sans-serif;
}
.login_box{
  border: 1px solid #CCCCCC;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  width: 481px;
  text-align: center;
  margin-bottom: 30px;
  background-color: #fff;
}
.login_page .form_section{
  margin: 35px 85px 50px;
}
.login_box img{
  margin: 10px auto;
}
.login_box .text_section h3{
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  color: #000;
  margin: 0px;
  font-family: 'Open Sans', sans-serif;
}
.login_box .text_section p{
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #000;
  margin: 25px 0px 20px;
  font-family: 'Montserrat', sans-serif;
}
.login_box .field_section{
  margin-bottom: 15px;
}
.login_box .field_section svg{
  margin-right: 15px;
  color: #CCCCCC;
}
.login_box .field_section input{
  width: 100%;
  background: transparent;
  border: 1px solid #ccc;
  padding: 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  border-radius: 3px;
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 5px;
}
.login_box .field_section input::placeholder{
  color: #ccc;
}
.login_box .field_section .chakra-form__error-message{
  font-size: 12px;
  line-height: 16px;
  font-family: 'Open Sans', sans-serif;
  margin: 0px;
  color: #FF0000;

}
.login_box .login_button{
  background: #0A83FF;
  border: 1px solid #0A83FF;
  border-radius: 3px;
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #fff;
  padding: 12px 20px;
  margin-bottom: 15px;
}
.login_box .forgot_link{
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: #2F6DC9;
  font-family: 'Open Sans', sans-serif;
  text-decoration: none;
}

header input.title__Input-sc-jcmnyx-0 {background: #fff !important;border: 1px solid #ccc !important;
  text-align: start;
  min-width: 60%;
  padding: 10px;
   margin: 0;
  font-size: 14px;
  line-height: 19px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  }
 /* .layout__LayerGrid-sc-1n0mp4m-0{
    grid: 'h h h h h h h' 90px
'. . . t . . .' minmax(52px,1fr)
'p b . c . f n' var(--viewport-height-px)
'. . . . . . .' 1fr
'w w w w w w w' 136px
'. . . . . . .' 16px / 1fr var(--page-nav-width) var(--page-nav-gap) var(--viewport-width-px) var(--page-nav-gap) var(--page-nav-width) 1fr !important;
  }*/
  header .button__ButtonRectangle-sc-1wfpfsz-0{
    padding: 8px 10px !important;
    border: 1px solid #ccc;
    background-color: #fff;
  }
  nav .button__ButtonRectangle-sc-1wfpfsz-0{
    border: 1px solid #ccc;
    background-color: #0A83FF;
    color: #fff;
    font-size: 14px;
    line-height: 17px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    padding: 11px 20px !important;
  }
  .components__MenuContainer-sc-1he0ofy-0{
    background-color: #fff !important;
    border: 1px solid #ccc !important;
    border-radius: 5px !important;
    margin-top: 5px !important;
    width: auto !important;
  }
  .components__MenuContainer-sc-1he0ofy-0 li span{
    font-family: 'Montserrat', sans-serif;
  }
  /*.constants__PopupContainer-sc-1f3rwe8-0{
    left: -20px !important;
  }*/

  .helpCenter__Wrapper-sc-12zoy5g-0 {display: none}
  .attribution__AttributionPill-sc-1j8k1n4-0 {display: none !important}

  .textSet__TextSetItem-sc-1hor9ow-0{background:#000 !important}
  .layout__PageMenuArea-sc-1n0mp4m-16 .menu__MenuWrapper-sc-13mg48i-0 div:first-child{
    display: none;
  }
/*Login Css*/

  .broad_cast_page .field_section .form-select{
    border: 1px solid #ccc;
    border-radius: 3px;
    width: -webkit-fill-available;
    padding: 12px;
    margin: 7px 0px 0px;
    font-size: 14px;
    line-height: 17px;
    background-color: transparent;
    width: 100%;
  }
  .field_section .chakra-textarea{
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 15px;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    color: #2B2F27;
  }
  .field_section label{
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    margin: 0px 0px 5px;
  }
  .field_section input{
    width: 100%;
    border: 1px solid #ccc;
    padding: 12px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    border-radius: 5px;
    margin: 0px 0px 3px;
  }
  .broad_cast_page .field_section{
    margin-top: 20px;
  }
  input{
    width: 100%;
    border: 1px solid #ccc;
    padding: 12px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    border-radius: 5px;
    margin: 0px 0px 3px;
  }
  .dropdown_link{
    padding: 0px;
    background-color: transparent;
    color: #000;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    border: 0px;
  }
  .dropdown_link:hover, .dropdown_link:focus, .dropdown_link:focus-visible, .dropdown_link:active{
    background-color: transparent !important;
    color: #000;
    border: 0px !important;
  }
  .dropdown_link:focus:not(:focus-visible){
    background-color: transparent !important;
  }

  .broad_cast_page .table_section tbody tr td{
    font-size: 14px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    line-height: 18px;
    color: #000;
    margin: 0px;
    border-top: 1px solid #ccc;
    padding: 15px 0px;
  }
  .broad_cast_page .table_section{
    width: 100%;
  }
  .broad_cast_page .table_section thead tr th{
    text-align: left;    
    font-size: 14px;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    line-height: 18px;
    color: #000;
    padding: 0px 0px 10px;
  }

  .setting_page .link_text{
    font-size: 14px;
    margin: 0px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: #0A83FF;
    line-height: 22px;
    cursor: pointer;
  }
  textarea#iframeCode{
    border-bottom: 1px solid #ccc;
    width: 100%;

  }
  textarea#iframeCode:focus-visible{
    outline: 0px;
    border: 0px;
    border-bottom: 1px solid #000;
  }

  @media screen and (max-width: 1920px){
    .setting_page .container{
      width: 1280px;
      max-width: 1280px;
    }
  }
  @media screen and (max-width: 1366px){
    .setting_page .container{
      width: 1150px;
      max-width: 1150px;
    }
  }
  @media screen and (max-width: 1280px){
    .setting_page .container{
      width: 1150px;
      max-width: 1150px;
    }
  }

`, "",{"version":3,"sources":["webpack://./assets/css/style.css"],"names":[],"mappings":"AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,oCAAoC;EACtC;EACA;IACE,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;EACvC;EACA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;EACvC;EACA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;EACvC;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,sBAAsB;;EAExB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,qCAAqC;IACrC,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,qCAAqC;IACrC,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qCAAqC;EACvC;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qCAAqC;EACvC;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;IAChB,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;;;;;;IAME,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,qCAAqC;EACvC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;;;EAGA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;;;EAGA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;;;EAGA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;EACvC;EACA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;EACvC;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,6BAA6B;IAC7B,iBAAiB;EACnB;EACA;IACE,6BAA6B;IAC7B,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;GACjB,qCAAqC;IACpC,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,wCAAwC;IACxC,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;EAChB;;;;AAIF,YAAY;;AAEZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,WAAW;EACX,cAAc;;AAEhB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,uCAAuC,2BAA2B,CAAC,iCAAiC;EAClG,iBAAiB;EACjB,cAAc;EACd,aAAa;GACZ,SAAS;EACV,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;;EAEvB;CACD;;;;;;;IAOG;EACF;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,6BAA6B;EAC/B;EACA;IACE,iCAAiC;IACjC,iCAAiC;IACjC,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,qCAAqC;EACvC;EACA;;IAEE;;EAEF,mCAAmC,aAAa;EAChD,4CAA4C,wBAAwB;;EAEpE,mCAAmC,0BAA0B;EAC7D;IACE,aAAa;EACf;AACF,YAAY;;EAEV;IACE,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;EACb;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;EACb;EACA;IACE,wCAAwC;IACxC,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,WAAW;;EAEb;EACA;IACE,YAAY;IACZ,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE;MACE,aAAa;MACb,iBAAiB;IACnB;EACF;EACA;IACE;MACE,aAAa;MACb,iBAAiB;IACnB;EACF;EACA;IACE;MACE,aAAa;MACb,iBAAiB;IACnB;EACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\nbody{\n    background: #EDF5FF !important;\n    margin: 0px;\n    padding: 0px;\n  }\n  .header_section{\n    background-color: #0A83FF;\n    padding: 0px 45px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .header_section .logo_section svg{\n    width: 134px;\n    height: 35px;\n  }\n  .header_section .navbar_section ul{\n    margin: 0px;\n    padding: 0px;\n    list-style: none;\n  }\n  .header_section .navbar_section ul li{\n    display: inline-block;\n  }\n\n  .header_section .navbar_section .link_section a:hover, .header_section .navbar_section .link_section a.active{\n    border-bottom: 4px solid #fff;\n    font-weight: 700;\n  }\n  .header_section .navbar_section .link_section a{\n    text-decoration: none;\n    color: #fff;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 19px;\n    font-family: 'Montserrat', sans-serif;\n    padding: 25px 20px;\n    display: block;\n    border-bottom: 4px solid transparent;\n  }\n  .header_section .user_name_section button{\n    background-color: transparent;\n    border: 0px;\n    text-align: left;\n  }\n  .header_section .btn-check:checked+.btn, .header_section .btn.active, .header_section .btn.show, .header_section .btn:first-child:active{\n    background-color: transparent;\n  }\n  .header_section .user_name_section .user_box{\n    border: 1px solid #fff;\n    width: 40px;\n    height: 40px;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 8px;\n  }\n  .header_section .user_name_section .user_box h2{\n    margin: 0px;\n    color: #fff;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 104%;\n    font-family: 'Montserrat', sans-serif;\n  }\n  .header_section .user_name_section .text_section p{\n    margin: 0px;\n    color: #fff;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 104%;\n    font-family: 'Montserrat', sans-serif;\n  }\n  .header_section .user_name_section .text_section h6{\n    margin: 0px;\n    color: #fff;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    line-height: 104%;\n    font-family: 'Montserrat', sans-serif;\n  }\n  .header_section .user_name_section .text_section h6 svg{\n    font-size: 8px;\n    margin-left: 5px;\n  }\n  .header_section .user_name_section .dropdown button::after{\n    display: none;\n  }\n  .d-flex{\n    display: flex;\n  }\n  .align-center{\n    align-items: center;\n  }\n  .dropdown-menu{\n    display: none;\n  }\n  .dropdown-menu.show{\n    display: block;\n    background-color: #fff;\n    \n  }\n  .header_section .user_name_section .dropdown-menu.show{\n    padding: 20px;\n    border-radius: 5px;\n    width: 100px;\n  }\n  .header_section .user_name_section .dropdown-menu.show ul{\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n  }\n  .header_section .user_name_section .dropdown-menu.show ul li:last-child{\n    margin-bottom: 0px;\n  }\n  .header_section .user_name_section .dropdown-menu.show ul li{\n    margin-bottom: 10px;\n  }\n  .header_section .user_name_section .dropdown-menu.show ul li a{\n    color: #000;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 104%;\n    font-family: 'Montserrat', sans-serif;\n    text-decoration: none;\n  }\n  .header_bottom_section{\n    background-color: #FF5656;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n  }\n  .header_bottom_section .subscribe_button{\n    background-color: #60DA00;\n    padding: 6px 15px;\n    border-radius: 5px;\n    font-weight: 700;\n    font-size: 14px;\n    color: #fff;\n    font-family: 'Montserrat', sans-serif;\n    margin-left: 20px;\n  }\n  .header_bottom_section p{\n    font-weight: 400;\n    font-size: 14px;\n    color: #fff;\n    font-family: 'Montserrat', sans-serif;\n    margin: 0px;\n  }\n  .mb-25{\n    margin-bottom: 25px;\n  }\n  .story_box_section ul{\n    margin: 0px;\n    padding: 0px;\n    list-style-type: none;\n  }\n  .story_box_section ul li{\n    display: inline-block;\n    margin-right: 15px;\n    margin-bottom: 15px;\n  }\n  .story_box_section ul li:last-child{\n    margin-right: 0px;\n  }\n  .story_box_section ul li ul{\n    display: block;\n  }\n  .story_box_section ul li ul li{\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    font-family: 'Montserrat', sans-serif;\n    margin: 0px 0px 10px;\n    font-weight: 400;\n    color: #000;\n  }\n  .story_box_section ul li ul li svg{\n    font-size: 24px;\n    color: #0A83FF;\n    margin-right: 10px;\n  }\n  .story_box_section .story_subscribe{\n    background-color: transparent;\n    padding: 15px 50px;\n    border: 1px solid #B8B5B5;\n    border-radius: 20px;\n    font-weight: 400;\n    font-size: 16px;\n    color: #B8B5B5;\n    font-family: 'Montserrat', sans-serif;\n  }\n  .story_box_section .story_subscribe:hover{\n    background-color: #0A83FF;\n    color: #fff;\n  }\n  .subscribe_box_section ul{\n    margin: 0px;\n    padding: 0px;\n    list-style-type: none;\n    display: flex;\n    justify-content: center;\n  }\n  .subscribe_box_section ul li{\n    margin-right: 15px;\n    margin-bottom: 15px;\n  }\n  .subscribe_box_section ul li:last-child{\n    margin-right: 0px;\n  }\n  .subscribe_box_section ul li ul{\n    display: block;\n  }\n  .subscribe_box_section ul li ul li{\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    font-family: 'Montserrat', sans-serif;\n    margin: 0px 0px 10px;\n    font-weight: 400;\n    color: #000;\n  }\n  .subscribe_box_section ul li ul li svg{\n    font-size: 24px;\n    color: #0A83FF;\n    margin-right: 10px;\n  }\n  .subscribe_box_section .story_subscribe{\n    background-color: transparent;\n    padding: 15px 50px;\n    border: 1px solid #B8B5B5;\n    border-radius: 20px;\n    font-weight: 400;\n    font-size: 16px;\n    color: #B8B5B5;\n    font-family: 'Montserrat', sans-serif;\n  }\n  .subscribe_box_section .story_subscribe:hover{\n    background-color: #0A83FF;\n    color: #fff;\n  }\n  .story_card{\n    background-color: #FFFFFF;\n    border: 1px solid #CCCCCC;\n    width: auto;\n    padding: 15px 18px;\n  }\n  .story_card .text_section{\n    margin: 10px 0px 0px;\n  }\n  .story_card .text_section h3{\n    font-size: 16px;\n    line-height: 19px;\n    font-family: 'Montserrat', sans-serif;\n    margin: 0px 0px 15px;\n    font-weight: 500;\n    color: #000;\n  }\n  .story_card .text_section .btn_view{\n    background-color: #0A83FF;\n    border: 1px solid #0A83FF;\n    padding: 5px 25px;\n    border-radius: 5px;\n    font-size: 12px;\n    line-height: 16px;\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 400;\n    color: #fff;\n    text-decoration: none;\n  }\n  .story_card .text_section a.btn_view{\n    display: block;\n  }\n  .story_card .icon_section ul{\n    margin: 0px;\n    padding: 0px;\n    list-style-type: none;\n  }\n  .story_card .icon_section li{\n    display: inline-block;\n    margin-right: 15px;\n    margin-bottom: 0px;\n  }\n  .story_card .delete_icon a svg{\n    color: #FF0000;\n    font-size: 16px;\n    margin-right: 10px;\n  }\n  .sidebarLayout__SidebarContainer-sc-hpe4no-1 .mediaPane__ButtonsWrapper-sc-usipec-3 div:first-child{\n    display: none;\n  }\n  ./*layout__PageAreaWithoutOverflow-sc-1n0mp4m-7 .edit__Element-sc-ybci2b-0 img{\n    left: 0px !important;\n  }*/\n\n\n  .publish_setting_page{\n    background-color: #EDF5FF;\n    padding: 30px 0px;\n  }\n  .container{\n    padding: 0px 45px;\n  }\n  .main_heading{\n    font-size: 32px;\n    font-weight: 300;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 42px;\n    color: #000;\n    margin: 0px;\n  }\n  .publish_setting_page .left_section{\n    width: 70%;\n  }\n  .publish_setting_page .right_section{\n    width: 30%;\n    margin-left: 25px;\n  }\n  .publish_setting_page .page_data{\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    padding: 20px;\n  }\n  .publish_setting_page .page_data .inner_main_heading{\n    font-size: 18px;\n    font-weight: 600;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 24px;\n    color: #000;\n    margin: 0px 0px 25px;\n  }\n  .publish_setting_page .page_data .form_section{\n    display: flex;\n  }\n  .publish_setting_page .field_section{\n    margin-bottom: 20px;\n  }\n  .publish_setting_page .field_section .form-label{\n    font-size: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 19px;\n    color: #000;\n    margin: 0px;\n  }\n  .publish_setting_page .field_section .form-control{\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    width: -webkit-fill-available;\n    padding: 12px;\n    margin: 7px 0px 0px;\n  }\n  .publish_setting_page .field_section .form-select{\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    width: -webkit-fill-available;\n    padding: 12px;\n    margin: 7px 0px 0px;\n    background-color: transparent;\n  }\n  .primary{\n    background-color: #0A83FF;\n    border-radius: 5px;\n    padding: 12px 40px;\n    border: 1px solid #0A83FF;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 19px;\n    cursor: pointer;\n    box-shadow: 0px 4px 4px 0px #00000040;\n  }\n  a.primary{\n    text-decoration: none;\n  }\n  .me-20{\n    margin-right: 20px;\n  }\n  .rightbar_section{\n    width: 100%;\n    height: auto;\n  }\n\n\n  .contact_page{\n    background-color: #EDF5FF;\n    padding: 20px 45px;\n  }\n  .contact_page .head_section{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0px 0px 25px;\n  }\n  .table_section tbody tr td a{\n    cursor: pointer;\n  }\n\n  .customer-tag{\n    background-color: #fff;\n    padding: 0px;\n  }\n  .customer-tag .head_section{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0px 0px 25px;\n  }\n\n  .main_heading{\n    font-size: 32px;\n    font-weight: 300;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 42px;\n    color: #000;\n    margin: 0px;\n  }\n  .me-5{\n    margin-right: 5px;\n  }\n  .secondary{\n    background-color: #f5f5f5;\n    border-radius: 5px;\n    padding: 12px 20px;\n    border: 1px solid #ccc;\n    color: #000;\n    font-size: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 19px;\n    cursor: pointer;\n  }\n  .contact_page .page_data{\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    padding: 20px;\n  }\n  .contact_page .table_section{\n    width: 100%;\n  }\n  .contact_page .table_section thead tr th{\n    text-align: left;    \n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 18px;\n    color: #000;\n    padding: 0px 0px 10px;\n  }\n  .contact_page .table_section .user_section{\n    display: flex;\n    align-items: center;\n  }\n  .contact_page .table_section .user_section .user_box{\n    width: 40px;\n    height: 40px;\n    background-color: #0A83FF;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 15px;\n  }\n  .contact_page .table_section .user_section .user_box h4{\n    margin: 0px;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 18px;\n    color: #fff;\n  }\n  .contact_page .table_section .user_section{\n    margin: 0px;\n    font-size: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 18px;\n    color: #000;\n  }\n  .contact_page .table_section tbody tr td{\n    font-size: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 18px;\n    color: #000;\n    margin: 0px;\n    border-top: 1px solid #ccc;\n    padding: 15px 0px;\n    vertical-align: middle;\n  }\n  .contact_page .table_section tbody tr td .edit_link{\n    color: #0A83FF;\n    margin-right: 10px;\n  }\n  .contact_page .table_section tbody tr td .delete_link{\n    color: #0A83FF;\n    margin-left: 10px;\n  }\n\n\n  .analytic_page{\n    background-color: #EDF5FF;\n    padding: 20px 45px;\n  }\n  .main_heading{\n    font-size: 32px;\n    font-weight: 300;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 42px;\n    color: #000;\n    margin: 0px;\n  }\n  .analytic_page .dashboard_box_section ul{\n    margin: 0px;\n    padding: 0px;\n    list-style: none;\n  }\n  .analytic_page .dashboard_box_section ul li{\n    display: inline-block;\n    margin-right: 20px;\n    margin-bottom: 40px;\n    width: 248px;\n  }\n  .analytic_page .dashboard_box_section .dashboard_box{\n    background-color: #0A83FF;\n    padding: 12px 20px;\n    border-radius: 10px;\n    border: 1px solid #ccc;\n  }\n  .analytic_page .dashboard_box_section .dashboard_box h1{\n    margin: 0px;\n    font-size: 32px;\n    font-weight: 600;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 48px;\n    color: #fff;\n  }\n  .analytic_page .dashboard_box_section .dashboard_box p{\n    margin: 0px;\n    font-size: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 19px;\n    color: #fff;\n  }\n  .analytic_page .page_data{\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    padding: 20px;\n    height: 500px;\n  }\n  .analytic_page .chart_section{\n    display: flex;\n  }\n  .analytic_page .w-40{\n    width: 40%;\n  }\n  .analytic_page .w-25{\n    width: 25%;\n  }\n  .me-10{\n    margin-right: 10px;\n  }\n\n\n  .setting_page{\n    background-color: #EDF5FF;\n    padding: 20px 0px;\n  }\n  .setting_page .container{\n    width: 1150px;\n    margin: auto;\n  }\n  .main_heading{\n    font-size: 32px;\n    font-weight: 300;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 42px;\n    color: #000;\n    margin: 0px;\n  }\n  .setting_page .page_data{\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    padding: 20px;\n  }\n  .setting_inner_section{\n    display: flex;\n  }\n  .w-75{\n    width: 75%;\n  }\n  .w-25{\n    width: 25%;\n  }\n  .w-30{\n    width: 30%;\n  }\n  .me-20{\n    margin-right: 20px;\n  }\n  .setting_page .left_nav_section{\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    padding: 5px 0px;\n  }\n  .setting_page .left_nav_section ul{\n    margin: 0px;\n    padding: 0px;\n    list-style: none;\n  } \n  .setting_page .left_nav_section ul li a{\n    display: flex;\n    font-size: 14px;\n    line-height: 19px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #000;\n    text-decoration: none;\n    padding: 10px 15px;\n  }\n  .setting_page .left_nav_section ul li a:hover{\n    background-color: #EDF5FF;\n    color: #0A83FF;\n  }\n  .setting_page .left_nav_section ul li a .img_icon{\n    margin-right: 15px;\n    display: block;\n  }\n  .setting_page .left_nav_section ul li a .img_active{\n    margin-right: 15px;\n    display: none;\n  }\n  .setting_page .left_nav_section ul li a.active .img_icon, .setting_page .left_nav_section ul li a:hover .img_icon{\n    margin-right: 15px;\n    display: none;\n  }\n  .setting_page .left_nav_section ul li a.active .img_active, .setting_page .left_nav_section ul li a:hover .img_active{\n    margin-right: 15px;\n    display: block;\n  }\n  .d-flex{\n    display: flex;\n  }\n  .setting_page .field_section{\n    margin-bottom: 30px;\n  }\n  .field_section .form-label{\n    font-size: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 19px;\n    color: #000;\n    margin: 0px;\n  }\n  .setting_page .field_section .form-control{\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    width: -webkit-fill-available;\n    padding: 12px;\n    margin: 7px 0px 0px;\n    font-size: 14px;\n    line-height: 17px;\n  }\n  .setting_page .field_section .form-select{\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    width: -webkit-fill-available;\n    padding: 12px;\n    margin: 7px 0px 0px;\n    font-size: 14px;\n    line-height: 17px;\n    background-color: transparent;\n  }\n  .setting_page .page_data .inner_main_heading{\n    font-size: 18px;\n    font-weight: 600;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 24px;\n    color: #000;\n    margin: 0px 0px 25px;\n  }\n  .setting_page .color_select_section ul{\n    margin: 10px 0px;\n    padding: 0px;\n    list-style: none;\n  }\n  .setting_page .color_select_section ul li{\n    display: inline-block;\n    margin-right: 10px;\n  }\n  .setting_page .color_select_section .color_box{\n    width: 40px;\n    height: 40px;\n    border-radius: 50px;\n    background-color: #DDE1E5;\n    position: relative;\n    display: flex;\n  }\n  .setting_page .color_select_section .color_box svg{\n    color: #fff;\n  }\n  .setting_page .color_select_section .color_box .cross_box{\n    width: 17px;\n    height: 17px;\n    background-color: #FF0000;\n    position: absolute;\n    top: 0px;\n    border-radius: 50px;\n    right: 0px;\n    display: none;\n  }\n  .setting_page .color_select_section .color_box:hover .cross_box{\n    display: flex;\n  }\n  .setting_page .table_section thead{\n    background-color: #363B78;\n  }\n  .setting_page .table_section{\n    border-spacing: 0px;\n    width: 100%;\n    border: 1px solid #ccc;\n    margin-bottom: 30px;\n  }\n  .setting_page .table_section thead tr th{\n    padding: 15px 12px;\n    border-bottom: 1px solid #ccc;\n    text-align: left;\n    color: #fff;\n    background-color: #0A83FF;\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 600;\n    font-family: 'Montserrat', sans-serif;\n  }\n  .setting_page .table_section tbody tr td{\n    padding: 10px 12px;\n    border-bottom: 1px solid #ccc;\n    text-align: left;\n    color: #000;\n    vertical-align: middle;\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 600;\n    font-family: 'Montserrat', sans-serif;\n  }\n  .setting_page .table_section tbody tr td .form-select{\n    width: 100%;\n    margin: 0px;\n  }\n  .setting_page .table_section tbody tr td .field_section{\n    margin-bottom: 0px;\n  }\n  .setting_page .table_section tbody tr td h1{\n    font-size: 26px;\n    margin: 0px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #000;\n    line-height: 43px;\n  }\n  .setting_page .table_section tbody tr td h2{\n    font-size: 22px;\n    margin: 0px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #000;\n    line-height: 36px;\n  }\n  .setting_page .table_section tbody tr td h3{\n    font-size: 18px;\n    margin: 0px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #000;\n    line-height: 24px;\n  }\n  .setting_page .table_section tbody tr td{\n    font-size: 14px;\n    margin: 0px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #000;\n    line-height: 19px;\n  }\n  .setting_page .table_section tbody tr td .edit_link{\n    color: #0A83FF;\n    margin-right: 10px;\n  }\n  .setting_page .table_section tbody tr td .delete_link {\n    color: #0A83FF;\n    margin-left: 10px;\n  }\n  .setting_page .table_section tbody tr td p{\n    font-size: 14px;\n    margin: 0px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #000;\n    line-height: 19px;\n  }\n  .setting_page .table_section tbody tr:last-child td{\n    border-bottom: 0px;\n  }\n  .setting_page .page_data .plan_section{\n    border-bottom: 1px solid #CCCCCC;\n    padding: 20px 0px;\n  }\n  .setting_page .page_data .plan_section h2{\n    font-size: 14px;\n    line-height: 19px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    color: #2B2F27;\n    margin: 0px 0px 20px;\n  }\n  .setting_page .page_data .plan_section .text_section h3{\n    font-size: 14px;\n    line-height: 19px;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    color: #2B2F27;\n    margin: 0px;\n  }\n  .setting_page .page_data .plan_section .text_section span{\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #5C5F62;\n    margin: 0px;\n  }\n  .setting_page .page_data .plan_section p{\n    font-size: 14px;\n    line-height: 19px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #2B2F27;\n    margin: 0px;\n  }\n  .setting_page .page_data .plan_section p.amount_section{\n    font-size: 16px;\n    line-height: 21px;\n    font-weight: 600;\n    font-family: 'Montserrat', sans-serif;\n    color: #2B2F27;\n    margin: 0px;\n  }\n  .setting_page .page_data .plan_section p span{\n    font-size: 10px;\n    line-height: 13px;\n    font-weight: 400;\n    color: #5C5F62;\n  }\n  .setting_page .page_data .plan_section .badge{\n    background-color: #ACE8CF;\n    border-radius: 15px;\n    padding: 4px 10px;\n    font-size: 8px;\n    line-height: 10px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #000;\n    text-transform: uppercase;\n  }\n  .setting_page .page_data .plan_section a{\n    text-decoration: none;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #2F6DC9;\n    margin: 0px;\n  }\n  .justify-content-between{\n    justify-content: space-between;\n  }\n  .align-items-end{\n    align-items: flex-end;\n  }\n  .mb-5{\n    margin-bottom: 5px;\n  }\n  .mb-20{\n    margin-bottom: 20px;\n  }\n  .ml-15{\n    margin-left: 15px;\n  }\n  .me-10{\n    margin-right: 10px;\n  }\n  .setting_page .page_data .invoices_section{\n    padding: 20px 0px;\n  }\n  .setting_page .page_data .invoices_section h2{\n    font-size: 14px;\n    line-height: 19px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    color: #2B2F27;\n    margin: 0px 0px 20px;\n  }\n  .setting_page .page_data .invoices_section .table_section{\n    border: 0px;\n    border-top: 1px solid #ccc;\n    border-bottom: 1px solid #ccc;\n  }\n  .setting_page .page_data .invoices_section .table_section tr td h4{\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 600;\n    font-family: 'Montserrat', sans-serif;\n    color: #2B2F27;\n    margin: 0px;\n  }\n  .setting_page .page_data .invoices_section .table_section tr td p{\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #5C5F62;\n    margin: 0px;\n  }\n  .setting_page .page_data .invoices_section .badge{\n    background-color: #ACE8CF;\n    border-radius: 15px;\n    padding: 4px 10px;\n    font-size: 8px;\n    line-height: 10px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #000;\n    text-transform: uppercase;\n  }\n  .setting_page .page_data .invoices_section a{\n    text-decoration: none;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #2F6DC9;\n    margin: 0px;\n  }\n  .setting_page .page_data .invoices_section a img{\n    margin-left: 10px;\n  }\n  .align-center{\n    align-items: center;\n  }\n  .justify-content-end{\n    justify-content: end;\n  }\n  .setting_page .page_data .owner_section{\n    border-bottom: 1px solid #ccc;\n    padding: 20px 0px;\n  }\n  .setting_page .page_data .owner_section .user_section{\n    border-bottom: 1px solid #ccc;\n    padding: 20px 0px;\n  }\n  .setting_page .page_data .owner_section .user_section:first-child{\n    padding: 0px 0px 20px;\n  }\n  .setting_page .page_data .owner_section .user_section:last-child{\n    padding: 20px 0px 0px;\n    border-bottom: 0px; \n  }\n  .setting_page .page_data .owner_section h2{\n    font-size: 14px;\n    line-height: 19px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    color: #2B2F27;\n    margin: 0px 0px 20px;\n  }\n  .setting_page .page_data .owner_section .text_section h2{\n    font-size: 14px;\n    line-height: 19px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    color: #2B2F27;\n    margin: 0px 0px 7px;\n  }\n  .setting_page .page_data .owner_section .text_section p{\n    font-size: 10px;\n    line-height: 14px;\n    font-weight: 400;\n   font-family: 'Montserrat', sans-serif;\n    color: #5C5F62;\n    margin: 0px;\n  }\n  .setting_page .page_data .owner_section .user_name_section{\n    display: flex;\n    align-items: center;\n  }\n  .setting_page .page_data .owner_section .user_dropdown button{\n    background-color: transparent !important;\n    border: 0px;\n    padding: 0px;\n  }\n  .setting_page .page_data .owner_section .user_dropdown button::after{\n    display: none;\n  }\n  .setting_page .page_data .owner_section .user_dropdown .dropdown-menu ul{\n    margin: 0px;\n    padding: 0px;\n    list-style: none;\n  }\n  .setting_page .page_data .owner_section .user_name_section .user_box{\n    width: 24px;\n    height: 24px;\n    background-color: #E3E4E6;\n    border-radius: 25px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 15px;\n  }\n  .setting_page .page_data .owner_section .user_name_section .user_box h4{\n    font-size: 10px;\n    line-height: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #8A8F94;\n    margin: 0px;\n  }\n  .setting_page .page_data .owner_section .user_name_section .text_section h2{\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #2F6DC9;\n    margin: 0px;\n  }\n  .setting_page .page_data .owner_section .user_name_section .text_section p{\n    font-size: 10px;\n    line-height: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #5C5F62;\n    margin: 0px;\n  }\n  .setting_page .page_data .owner_section a{\n    text-decoration: none;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #2F6DC9;\n    margin: 0px;\n  }\n  .create_user_form{\n    padding: 10px;\n  }\n  .create_user_form .field_section label{\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    margin: 0px 0px 5px;\n  }\n  .create_user_form .field_section input{\n    width: 100%;\n    border: 1px solid #ccc;\n    padding: 12px;\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    border-radius: 5px;\n    margin: 0px 0px 3px;\n  }\n  .create_user_form .field_section{\n    margin-bottom: 10px;\n  }\n  .create_user_form .field_section .chakra-form__error-message{\n    font-size: 12px;\n    line-height: 15px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #FF0000;\n  }\n\n\n\n/*Login Css*/\n\n.login_page{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  height: 100vh;\n}\n.login_page p{\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #000;\n  margin: 0px;\n  font-family: 'Montserrat', sans-serif;\n}\n.login_box{\n  border: 1px solid #CCCCCC;\n  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 5px;\n  width: 481px;\n  text-align: center;\n  margin-bottom: 30px;\n  background-color: #fff;\n}\n.login_page .form_section{\n  margin: 35px 85px 50px;\n}\n.login_box img{\n  margin: 10px auto;\n}\n.login_box .text_section h3{\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 27px;\n  color: #000;\n  margin: 0px;\n  font-family: 'Open Sans', sans-serif;\n}\n.login_box .text_section p{\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 21px;\n  color: #000;\n  margin: 25px 0px 20px;\n  font-family: 'Montserrat', sans-serif;\n}\n.login_box .field_section{\n  margin-bottom: 15px;\n}\n.login_box .field_section svg{\n  margin-right: 15px;\n  color: #CCCCCC;\n}\n.login_box .field_section input{\n  width: 100%;\n  background: transparent;\n  border: 1px solid #ccc;\n  padding: 12px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 19px;\n  border-radius: 3px;\n  font-family: 'Open Sans', sans-serif;\n  margin-bottom: 5px;\n}\n.login_box .field_section input::placeholder{\n  color: #ccc;\n}\n.login_box .field_section .chakra-form__error-message{\n  font-size: 12px;\n  line-height: 16px;\n  font-family: 'Open Sans', sans-serif;\n  margin: 0px;\n  color: #FF0000;\n\n}\n.login_box .login_button{\n  background: #0A83FF;\n  border: 1px solid #0A83FF;\n  border-radius: 3px;\n  width: 100%;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #fff;\n  padding: 12px 20px;\n  margin-bottom: 15px;\n}\n.login_box .forgot_link{\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 14px;\n  color: #2F6DC9;\n  font-family: 'Open Sans', sans-serif;\n  text-decoration: none;\n}\n\nheader input.title__Input-sc-jcmnyx-0 {background: #fff !important;border: 1px solid #ccc !important;\n  text-align: start;\n  min-width: 60%;\n  padding: 10px;\n   margin: 0;\n  font-size: 14px;\n  line-height: 19px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  }\n /* .layout__LayerGrid-sc-1n0mp4m-0{\n    grid: 'h h h h h h h' 90px\n'. . . t . . .' minmax(52px,1fr)\n'p b . c . f n' var(--viewport-height-px)\n'. . . . . . .' 1fr\n'w w w w w w w' 136px\n'. . . . . . .' 16px / 1fr var(--page-nav-width) var(--page-nav-gap) var(--viewport-width-px) var(--page-nav-gap) var(--page-nav-width) 1fr !important;\n  }*/\n  header .button__ButtonRectangle-sc-1wfpfsz-0{\n    padding: 8px 10px !important;\n    border: 1px solid #ccc;\n    background-color: #fff;\n  }\n  nav .button__ButtonRectangle-sc-1wfpfsz-0{\n    border: 1px solid #ccc;\n    background-color: #0A83FF;\n    color: #fff;\n    font-size: 14px;\n    line-height: 17px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    padding: 11px 20px !important;\n  }\n  .components__MenuContainer-sc-1he0ofy-0{\n    background-color: #fff !important;\n    border: 1px solid #ccc !important;\n    border-radius: 5px !important;\n    margin-top: 5px !important;\n    width: auto !important;\n  }\n  .components__MenuContainer-sc-1he0ofy-0 li span{\n    font-family: 'Montserrat', sans-serif;\n  }\n  /*.constants__PopupContainer-sc-1f3rwe8-0{\n    left: -20px !important;\n  }*/\n\n  .helpCenter__Wrapper-sc-12zoy5g-0 {display: none}\n  .attribution__AttributionPill-sc-1j8k1n4-0 {display: none !important}\n\n  .textSet__TextSetItem-sc-1hor9ow-0{background:#000 !important}\n  .layout__PageMenuArea-sc-1n0mp4m-16 .menu__MenuWrapper-sc-13mg48i-0 div:first-child{\n    display: none;\n  }\n/*Login Css*/\n\n  .broad_cast_page .field_section .form-select{\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    width: -webkit-fill-available;\n    padding: 12px;\n    margin: 7px 0px 0px;\n    font-size: 14px;\n    line-height: 17px;\n    background-color: transparent;\n    width: 100%;\n  }\n  .field_section .chakra-textarea{\n    width: 100%;\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    padding: 15px;\n    font-size: 12px;\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 400;\n    color: #2B2F27;\n  }\n  .field_section label{\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    margin: 0px 0px 5px;\n  }\n  .field_section input{\n    width: 100%;\n    border: 1px solid #ccc;\n    padding: 12px;\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    border-radius: 5px;\n    margin: 0px 0px 3px;\n  }\n  .broad_cast_page .field_section{\n    margin-top: 20px;\n  }\n  input{\n    width: 100%;\n    border: 1px solid #ccc;\n    padding: 12px;\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    border-radius: 5px;\n    margin: 0px 0px 3px;\n  }\n  .dropdown_link{\n    padding: 0px;\n    background-color: transparent;\n    color: #000;\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    border: 0px;\n  }\n  .dropdown_link:hover, .dropdown_link:focus, .dropdown_link:focus-visible, .dropdown_link:active{\n    background-color: transparent !important;\n    color: #000;\n    border: 0px !important;\n  }\n  .dropdown_link:focus:not(:focus-visible){\n    background-color: transparent !important;\n  }\n\n  .broad_cast_page .table_section tbody tr td{\n    font-size: 14px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 18px;\n    color: #000;\n    margin: 0px;\n    border-top: 1px solid #ccc;\n    padding: 15px 0px;\n  }\n  .broad_cast_page .table_section{\n    width: 100%;\n  }\n  .broad_cast_page .table_section thead tr th{\n    text-align: left;    \n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 18px;\n    color: #000;\n    padding: 0px 0px 10px;\n  }\n\n  .setting_page .link_text{\n    font-size: 14px;\n    margin: 0px;\n    font-weight: 400;\n    font-family: 'Montserrat', sans-serif;\n    color: #0A83FF;\n    line-height: 22px;\n    cursor: pointer;\n  }\n  textarea#iframeCode{\n    border-bottom: 1px solid #ccc;\n    width: 100%;\n\n  }\n  textarea#iframeCode:focus-visible{\n    outline: 0px;\n    border: 0px;\n    border-bottom: 1px solid #000;\n  }\n\n  @media screen and (max-width: 1920px){\n    .setting_page .container{\n      width: 1280px;\n      max-width: 1280px;\n    }\n  }\n  @media screen and (max-width: 1366px){\n    .setting_page .container{\n      width: 1150px;\n      max-width: 1150px;\n    }\n  }\n  @media screen and (max-width: 1280px){\n    .setting_page .container{\n      width: 1150px;\n      max-width: 1150px;\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
